
import { Link } from 'react-router-dom';

// 熱門標籤數據
const popularTags = [
  { name: '搬家準備', count: 8, icon: 'ri-checkbox-circle-line', color: 'from-teal-500 to-emerald-600' },
  { name: '搬家費用', count: 6, icon: 'ri-money-dollar-circle-line', color: 'from-green-500 to-teal-600' },
  { name: '打包技巧', count: 5, icon: 'ri-box-3-line', color: 'from-amber-500 to-orange-600' },
  { name: '搬家省錢', count: 5, icon: 'ri-wallet-line', color: 'from-emerald-500 to-green-600' },
  { name: '搬家當天', count: 4, icon: 'ri-calendar-check-line', color: 'from-cyan-500 to-teal-600' },
  { name: '家電搬運', count: 4, icon: 'ri-fridge-line', color: 'from-violet-500 to-purple-600' },
  { name: '搬家保險', count: 3, icon: 'ri-shield-check-line', color: 'from-rose-500 to-pink-600' },
  { name: '鋼琴搬運', count: 3, icon: 'ri-music-2-line', color: 'from-indigo-500 to-blue-600' },
  { name: '辦公室搬遷', count: 3, icon: 'ri-building-line', color: 'from-slate-500 to-gray-600' },
  { name: '斷捨離', count: 2, icon: 'ri-delete-bin-line', color: 'from-orange-500 to-red-600' },
];

// AI 口語化問題標籤
const aiVoiceTags = [
  { name: '搬家前要準備什麼', articleId: 104 },
  { name: '搬家公司怎麼選', articleId: 105 },
  { name: '搬家要多少錢', articleId: 106 },
  { name: '搬家當天要注意什麼', articleId: 107 },
  { name: '搬家怎麼省錢', articleId: 108 },
];

const PopularTagsSection = () => {
  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* 標題區 */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-teal-100 to-emerald-100 rounded-full mb-4">
            <i className="ri-fire-line text-orange-500 text-xl"></i>
            <span className="text-teal-700 font-semibold">熱門搜尋</span>
          </div>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            <strong>熱門標籤</strong>快速瀏覽
          </h2>
          <p className="text-base sm:text-lg text-gray-600 max-w-2xl mx-auto">
            透過熱門標籤快速找到您需要的<strong>搬家知識</strong>，{popularTags.length}+ 個分類、50+ 篇專業文章
          </p>
        </div>

        {/* AI 口語化問題區塊 */}
        <div className="mb-10">
          <div className="flex items-center gap-2 mb-4">
            <div className="w-8 h-8 bg-gradient-to-br from-teal-500 to-cyan-600 rounded-lg flex items-center justify-center">
              <i className="ri-voice-recognition-line text-white"></i>
            </div>
            <h3 className="text-lg font-bold text-gray-900">🔥 大家都在問</h3>
          </div>
          <div className="flex flex-wrap gap-3">
            {aiVoiceTags.map((tag, index) => (
              <Link
                key={index}
                to={`/knowledge/article/${tag.articleId}`}
                className="group relative px-5 py-3 bg-gradient-to-r from-teal-50 to-emerald-50 border-2 border-teal-200 rounded-2xl hover:border-teal-400 hover:shadow-lg transition-all cursor-pointer"
              >
                <div className="flex items-center gap-2">
                  <i className="ri-question-line text-teal-600"></i>
                  <span className="font-medium text-gray-800 group-hover:text-teal-700 transition-colors">
                    「{tag.name}？」
                  </span>
                  <i className="ri-arrow-right-line text-teal-500 opacity-0 group-hover:opacity-100 transition-opacity"></i>
                </div>
              </Link>
            ))}
          </div>
        </div>

        {/* 熱門標籤網格 */}
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-4 mb-10">
          {popularTags.map((tag, index) => (
            <Link
              key={index}
              to={`/knowledge/tags?tag=${encodeURIComponent(tag.name)}`}
              className="group relative bg-white rounded-2xl p-4 border border-gray-200 hover:border-teal-300 hover:shadow-xl transition-all cursor-pointer overflow-hidden"
            >
              {/* 背景裝飾 */}
              <div className={`absolute top-0 right-0 w-20 h-20 bg-gradient-to-br ${tag.color} opacity-10 rounded-full -translate-y-1/2 translate-x-1/2 group-hover:opacity-20 transition-opacity`}></div>
              
              <div className="relative">
                <div className={`w-10 h-10 bg-gradient-to-br ${tag.color} rounded-xl flex items-center justify-center mb-3 group-hover:scale-110 transition-transform`}>
                  <i className={`${tag.icon} text-white text-lg`}></i>
                </div>
                <h4 className="font-bold text-gray-900 mb-1 group-hover:text-teal-700 transition-colors text-sm sm:text-base">
                  #{tag.name}
                </h4>
                <div className="flex items-center gap-1 text-xs text-gray-500">
                  <i className="ri-article-line"></i>
                  <span>{tag.count} 篇文章</span>
                </div>
              </div>
              
              {/* 熱門標記 */}
              {index < 3 && (
                <div className="absolute top-2 right-2">
                  <span className="px-2 py-0.5 bg-orange-100 text-orange-600 text-xs font-semibold rounded-full flex items-center gap-1">
                    <i className="ri-fire-fill"></i>
                    熱門
                  </span>
                </div>
              )}
            </Link>
          ))}
        </div>

        {/* 標籤雲 */}
        <div className="bg-gradient-to-br from-gray-50 to-teal-50 rounded-3xl p-6 sm:p-8 border border-gray-200">
          <div className="flex items-center justify-between mb-6">
            <h3 className="text-lg font-bold text-gray-900 flex items-center gap-2">
              <i className="ri-price-tag-3-line text-teal-600"></i>
              更多標籤
            </h3>
            <Link
              to="/knowledge/tags"
              className="text-teal-600 hover:text-teal-700 font-medium text-sm flex items-center gap-1 cursor-pointer whitespace-nowrap"
            >
              查看全部
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
          
          <div className="flex flex-wrap gap-2 sm:gap-3">
            {[
              '易碎品', '包裝材料', '紙箱選擇', '物品分類', '計價方式', '預算規劃',
              '理賠流程', '權益保護', '寵物搬家', '親子搬家', '銀髮族搬家', '新婚搬家',
              '夏季搬家', '冬季搬家', '搬家風水', '入宅吉日', '長途搬家', '跨縣市搬家',
              '廢棄物清運', '環保搬家', '收納整理', '極簡生活'
            ].map((tag, index) => (
              <Link
                key={index}
                to={`/knowledge/tags?tag=${encodeURIComponent(tag)}`}
                className="px-3 sm:px-4 py-1.5 sm:py-2 bg-white text-gray-700 text-xs sm:text-sm rounded-full border border-gray-200 hover:border-teal-400 hover:bg-teal-50 hover:text-teal-700 transition-all cursor-pointer whitespace-nowrap"
              >
                #{tag}
              </Link>
            ))}
          </div>
        </div>

        {/* CTA 區塊 */}
        <div className="mt-10 text-center">
          <Link
            to="/knowledge/tags"
            className="inline-flex items-center gap-2 px-8 py-4 bg-gradient-to-r from-teal-600 to-emerald-600 text-white rounded-full font-semibold hover:shadow-xl hover:scale-105 transition-all cursor-pointer whitespace-nowrap"
          >
            <i className="ri-compass-discover-line text-xl"></i>
            探索所有標籤分類
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default PopularTagsSection;
